import AddIcon from '@mui/icons-material/Add';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import OrdersCard from "../../../../components/global/cards/orders/OrdersCard";
import { ORDER_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import MpAddOrderRelation from "../../../../components/global/ModalsProgression/MpAddOrderRelation/MpAddOrderRelation";
import ButtonGroup, { ButtonGroupWithIconLeft } from "../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../components/theme/label/ShLabel";
import ShCopyButton from '../../../../components/theme/ShCopy';
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../components/theme/text/Text";
import { useGetOrdersQuery } from "../../../../newapi/order/ordersSlice";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { tokens } from "../../../../theme";
import { UserPrivileges } from '../../../../utils/permissions';
import { general_states } from "../../../../utils/staticEnums";
import { selectEnvironmentid } from "../../../../newapi/global/settingsSlice";

import  UploadOutlinedIcon  from '@mui/icons-material/UploadOutlined';
import MImportData from "../../../../components/global/Modals/MImportData";
import { orderColumns } from "../../../../components/theme/import/ImportColumnHelper";
import { ImportStandAloneFileLogo } from "../../../../utils/importColumnDefinitions";
import { ENV_TYPES } from '../../../../components/global/Sidebar';
import { useGetRelationForMenuQuery } from '../../../../newapi/global/relation/relationSlice';
import ShDataGrid3 from '../../../../components/theme/datagrid3/ShDataGrid3';
import { RELATION_ORDERS_FAMILY } from '../family';
import { GRANULARITY_KEYS } from '../../../../components/theme/datagrid3/groupingDateGranularities';
import { RELATION_ORDERS_DEFAULT } from '../../../../components/theme/datagrid3/groupingPresets/GroupingPresets';
import SHQuickAction from '../../../../components/theme/Modal/SHQuickAction';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
const SpOrderDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    return props.hasCreatePermission ?
        <ButtonGroup version={2}>
            {props.importAllowed && (
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "grey" : "grey"} 
                onClick={() => {
                    props.importOrdersOpen();
                }}
                endIcon={<UploadOutlinedIcon/>}
                variant="contained"
            >
                {t('import')}
            </Shbutton>
            )}
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t('new_order')}
            </Shbutton>
        </ButtonGroup> : <></>
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [ORDER_FILTER_KEYS.PRODUCT,ORDER_FILTER_KEYS.B2B_ORDERS, ORDER_FILTER_KEYS.WEBSHOP],
};

const OutBoundOrders = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const [config, setConfig] = useState({
        [ORDER_FILTER_KEYS.STATE.backend_key]:[general_states.OPEN, general_states.PICKING_IN_PROGRESS, general_states.FULLYPICKED, general_states.REPLENISH, general_states.ECHECKPAUSED, general_states.TO_PROCESS, general_states.ACTION_REQUIRED_WAREHOUSE],
        "relationId": useSelector((state) => state.settings.environment.selectedId)
    });

    const selectedEnvironmentId = useSelector(selectEnvironmentid);
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    
    const {data:relationMenuData,isFetching:isFetching2,isLoading:isLoading2} = useGetRelationForMenuQuery(selectedEnvironmentId, {
        skip: selectedEnvironmentType !== ENV_TYPES[200]
    });

    const [importAllowed, setImportAllowed] = useState(null);

    useEffect(() => {
        if (relationMenuData) {
            const importOrderSetting = relationMenuData.settings?.find(x => x.key === "relation_import_order");
            if (importOrderSetting && importOrderSetting.value === "true") {
                setImportAllowed(true);
            }
        }
    }, [relationMenuData])

    const [importOrdersModalOpen,setImportOrdersModalOpen] = useState(false);
    const importOrdersModal = {
        open: importOrdersModalOpen,
        setOpen: setImportOrdersModalOpen,
    }

    const importOrdersOpen = () => {
        setImportOrdersModalOpen(true);
    }

    const importOrdersClose = () => {
        setImportOrdersModalOpen(false);
    }

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_ORDER_MANAGE])
    );

    const [spLoading, setSpLoading] = useState();

    const ref = useRef();
    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const [defaultTab, setDefaultTab] = useState(null);
    const handleClose = (response) => {
        setAddModalOpen(false);
        const newOrderState = response?.data?.state ?? response?.state;
        const newOrderId = response?.data?.id ?? response?.id;
        if (newOrderState === general_states.ACTION_REQUIRED_CUSTOMER && newOrderId) {
            if (!spLoading) setSpLoading(true);
            setOrderId(newOrderId);
            orderIdRef.current = newOrderId;
            setDefaultTab(2);
            setIsExtended(true);
        }
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions 
                    importOrdersOpen={importOrdersOpen} handleOpen={handleOpen} importAllowed={importAllowed} hasCreatePermission={hasCreatePermission}></GridActions>,
        });

        return () => {
            
        }
    },[]);

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (params) => {
        if (!params) return;
    
        const neworderId = parseInt(params.row.id);
        // Only update state if the orderId has actually changed
        if (orderIdRef.current !== neworderId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setOrderId(neworderId);
            orderIdRef.current = neworderId; // Update the ref to the new value
        }
        setDefaultTab(null);
        setIsExtended(true);
    };

    const columns = [
        {
            field: "barcode",
            headerName: t('order'),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box
                            sx={{
                                minWidth:"100%",
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                position:"relative",
                                whiteSpace:"nowrap",
                                wordBreak:"keep-all",
                                textOverflow:"ellipsis",
                                overflow:"hidden",
                                gap:2,

                            }}
                        >
                            <Text noBreak>{params.row.barcode}</Text>
                            {params.row.remark &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("remark")}</Text>
                                            <Text>{params.row.remark}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <CommentOutlinedIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                        </Box>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.barcode}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "deliveryName", headerName: t("name"),flex:1, 
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.deliveryName
            }
        },
        {field: "webshopreference", headerName: t("webshopreference"),flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{`${params.row.webshopcredentials?.description ?? t("self_created")} - ${params.row.webshopreference} (${params.row.deliveryCountry ? params.row.deliveryCountry.toUpperCase() : ""})`}</Text>)
            }
        },
        {field: "deliveryMethod", headerName: t("delivery_method"),flex:1, sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
               return t(params.row.deliveryMethod);
            }
        },
        {
            field: "date_planned", 
            headerName: t("date_planned_shipment"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                let planned = new Date(params.row.date_planned);
                let sent = params.row.date_sent ? new Date(params.row.date_sent) : null;
              
                return (
                    <ShLabel size={32} fitted variant={theme.palette.mode === "dark" ? "blue" : "primary"} palette="normal">
                        {!sent && planned.toLocaleDateString(i18n.language)}
                        {sent && sent.toLocaleDateString(i18n.language)}
                    </ShLabel>
                );
            }
        },
        {field: "orderlinesCount", headerName: t("orderlines_count"),flex:1, sortable: false,
        renderCell: (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.row.amountOfLines
        }},
        // {field: "shipper", headerName: t("shipper_name"),flex:1,
        // renderCell: (params) => {
        //     if(params.row.skeleton) {
        //         return <ShTextSkeleton/>
        //     }
        //     return params.row.shipper?.name
        // }},
        {
            field: "state",
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                return (
                    <ShLabel size={32} palette="normal" variant={theme.palette.mode === "dark" ? "blue" : "primary"}>
                      {t("processing")}
                    </ShLabel>
                  );
            },
        },
       {
            field: "createdAt",
            headerName: t("date_created"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const date = new Date(params.row.createdAt);
                const dateStr = date.toLocaleDateString(i18n.language, { dateStyle: 'short' });
                const timeStr = date.toLocaleTimeString(i18n.language, { timeStyle: 'short' });

                return (
                    <Text>
                        {dateStr}{' '}<Text light>{timeStr}</Text>
                    </Text>
                );
            },
            grouping: RELATION_ORDERS_DEFAULT.CREATED_AT,
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <OrdersCard 
                    onClick={() => getOrderDetails(params)} 
                    skeleton={params.row.skeleton ?? false} {...params.row}  />
                )
            }
        }
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3 
                key={theme.palette.mode}
                gridKey={RELATION_ORDERS_FAMILY.ACTIVE.gridKey}
                family={RELATION_ORDERS_FAMILY}
                pollingInterval={true}
                content={useGetOrdersQuery}
                config={config}
                gridActions={<GridActions
                importOrdersOpen={importOrdersOpen} handleOpen={handleOpen} importAllowed={importAllowed} hasCreatePermission={hasCreatePermission}></GridActions>}
                title={t('processing') }
                gridOptions={gridOptions}
                sortModel={{field: columns[7].field,type:"DESC"}}
                sort={{field: columns[7].field,type:"DESC"}}
                enableGrouping={true}
                columns={columns}
                // rows={data}
                onRowClick={getOrderDetails}>
            </ShDataGrid3>

            {spLoading &&
                <SpOrderDetails
                    defaultTab={defaultTab}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderId={orderId}
                    // data={orderData}
                    // relation={true}
                    canReserveOrderLines={true}
                />
            }

            <MImportData
                onOpen={() => importOrdersModal.setOpen(true)} 
                onClose={() => importOrdersModal.setOpen(false)} 
                open={importOrdersModal.open} 
                handleClose={importOrdersClose} 

                logo={<ImportStandAloneFileLogo Icon={CallMadeOutlinedIcon} />}
                title={t("import_orders")}
                fileType={"bestellingen"}
                columns={orderColumns}
                exampleFile={"/Voorbeeldbestandbestellingimport.xlsx"}
            />

            <MpAddOrderRelation onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose} />
        </Box>
    );
}

export default OutBoundOrders;